<template>
    <div id="aroundList">
        <!-- <mt-header :title="title" >
            <router-link to="" slot="left">
                <mt-button icon="back" @click.native="goBack"></mt-button>
            </router-link>
        </mt-header> -->
        <top :title="title"></top>
        <div class="setFix"></div>
        <!-- 无数据 -->
        <div class="noLists" v-show="showSwitch == true&&pois.length==0">
            <img src="~@/assets/imgs/bg.png" alt="">
            <p>这里空空如也~</p>
        </div>
        <div class="aroundWrap" ref="aroundList" :style="{height: fullHeight - 44 + 'px'}">
            <div class="onetag"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="disabled"
            infinite-scroll-distance="0"
            v-show="showSwitch == false&&pois.length!=0">
                <div v-for="(item,i) in pois" :key="i" >
                    <div class="item-list">
                        <p class="name" @click="intoDetail(item.id,item.distance)">{{item.name}}</p>
                        <p class="address">{{(item.distance<1000)?item.distance+'m':((item.distance)/1000).toFixed(1)+'km'}}丨{{item.address}}</p>
                        <div class="btm clearfix">
                            <div class="left" @click="gowhere(item.location)">
                                去这里
                            </div>
                            <div class="right" :class="item.tel.length==0?'notel':''" @click="call(item.tel)">
                                电话
                            </div>
                        </div>
                    </div>
                    <div class="line5"></div>
                </div>
                <div ref="bottom" style="display: block;text-align: center;border-bottom:0;height: 30px;"></div>
            </div>
            <!-- <div class="isfoot" v-show="isFoot"> 我已经到底了...</div> -->
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { Indicator } from 'mint-ui';
import Top from '@/component/top/top'
export default {
    data() {
        return {
            showSwitch:false,
            title:'',
            pois:[],
            disabled:false,
            page:1,
            setType:'',
            isFoot:false,
            fullHeight: document.documentElement.clientHeight
        }
    },
    components:{
        Top
    },
    created() {
        let type = this.$route.query.type
        this.setType = this.$route.query.type
        if(type == 5) {
            this.title = '周边美食'
        }else if(type == 6) {
            this.title = '周边超市'
        }else if(type == 7) {
            this.title = '周边商场'
        }else if(type == 8) {
            this.title = '周边银行'
        }else if(type == 9) {
            this.title = '周边药店'
        }else if(type == 10) {
            this.title = '周边酒店'
        }else if(type == 11) {
            this.title = '周边休闲'
        }
    },
    computed:{
        location() {
            return localStorage.getItem('lon')+','+localStorage.getItem('lat')
        }
    },
    methods:{
        goQ() {
            window.history.back();
        },
        intoDetail(id,disc) {
            this.$router.push({path:'/adetail',query:{title:this.title,id:id,disc:disc}})
        },
        getLists(page,type) {
            Indicator.open()
            this.disabled = true;
            axios.get(`//restapi.amap.com/v3/place/around?key=${localStorage.getItem('key')}&location=${this.location}&types=${type}&page=${page}&extensions=all`).then((res) => {
                    Indicator.close()
                    if(res.data.pois.length!=0) {
                        this.pois = this.pois.concat(res.data.pois)
                        ++this.page
                        this.disabled = false;
                        if(res.data.count<20) {
                            this.isFoot = true
                        }
                    }else if(page<=1){
                        this.showSwitch = true
                        this.disabled = true;
                    }
                }).catch(error => {
                    Indicator.close()
                    if (page == 1) {
                        return
                    }
                    this.$refs.aroundList.scrollTop = this.$refs.aroundList.scrollTop - this.$refs.bottom.offsetHeight
                    this.disabled = false
                })  
        },
        loadMore() {
            this.disabled = true
            if(this.setType=='5') {  
                this.getLists(this.page,'050000')
            }else if(this.setType=='6'){
                this.getLists(this.page,'060400')
            }else if(this.setType=='7'){
                this.getLists(this.page,'060101')
            }else if(this.setType=='8') {
                this.getLists(this.page,'160100')
            }else if(this.setType=='9') {
                this.getLists(this.page,'090600|090601|090602')
            }else if(this.setType=='10') {
                this.getLists(this.page,'100000')
            }else if(this.setType=='11') {
                this.getLists(this.page,'080000')
            }
            // 100000 酒店

            // 药店  090600 090601 090602
            //休闲  080000
            Indicator.close()
        },
        call(tel) {
            if(tel.length!=0) {
                this.isScreen(`app://tel?mobile=${tel}`)
            }
        },
        gowhere(lon) {
            this.isScreen(`app://map?lng=${lon.split(',')[0]}&lat=${lon.split(',')[1]}`)
        }
    }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
.aroundWrap{
    height: 100vh;
    overflow: scroll;
    border-top:0;
}
#aroundList{
    .onetag{
        &:nth-child(1){
            border-top:1px solid #d8d8d8;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/aroundlist/aroundlist.vue